import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34f5734a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-button-section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loadingContainer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ball" }),
  /*#__PURE__*/_createElementVNode("div", { class: "ball" }),
  /*#__PURE__*/_createElementVNode("div", { class: "ball" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}